// import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Estado } from "../../actions/Estado";
import { useProducto } from "../../actions/Producto.jsx";
import style from "../../styles/form.module.css";
// import { TipoInsumo } from "../../actions/tipoinsumo";
import { Headphones } from "lucide-react";

function ABMProductos() {
   // const token = localStorage.getItem("token");
   // const url = process.env.REACT_APP_URL_DIR + "product";
   const estados = Estado();
   // const queryClient = useQueryClient();
   const { crearProducto } = useProducto();
   // var urlProd = url;
   // var metodo = "POST";
   // const tipoinsu = TipoInsumo();
   const location = useLocation();
   const { state } = location;

   const navigate = useNavigate();
   const [input, setInput] = useState({
      id_primary: state ? state.id_primary : 0,
      id: state ? state.id : 0,
      companyId: state ? state.companyId : 0,
      descripcion: state ? state.descripcion : "",
      cod_proveedor: state ? state.cod_proveedor : "",
      dolar: state ? state.dolar : 0,
      stock: state ? state.stock : 0,
      size: state ? state.size : 0,
      gauge: state ? state.gauge : 0,
      esteril: state ? state.esteril : 0,
      tipoprod: 1,
      cod_status: state ? state.cod_status : "1",
   });

   var btnGrabar = true;

   console.log("input: ", input);
   function handleChange(e) {
      e.preventDefault();
      setInput({
         ...input,
         [e.target.name]: e.target.value,
      });
   }

   const handleSubmit = async (e) => {
      e.preventDefault();
      console.log("handleSubmit: ", input);
      await crearProducto.mutateAsync(input);
      window.location.href = "/Producto";
      // navigate("/Producto");
   };

   // const { mutate } = useMutation({
   //    mutationFn: (newPost) =>
   //       fetch(urlProd, {
   //          method: metodo,
   //          body: JSON.stringify(newPost),
   //          headers: {
   //             Authorization: `Bearer ${token}`,
   //             "Content-Type": "application/json",
   //          },
   //       }).then((res) => res.json()),
   //    onSuccess: () => {
   //       queryClient.invalidateQueries(["producto"]);
   //       window.location.href = "/Producto";
   //    },
   //    onError: () => {
   //       alert("Error");
   //    },
   // });

   return (
      <>
         <div className={style.container}>
            <div className="bg-white w-90">
               <form
                  onSubmit={(e) => handleSubmit(e)}
                  // className="form-style-Prod"
               >
                  <div style={{ display: "flex", gap: "10px" }}>
                     <Headphones style={{ color: "white" }} />
                     <h2 className="justify-self-center">Datos del Producto</h2>
                  </div>
                  <br />
                  <div>
                     {input.id !== 0 ? (
                        <div>
                           <span className={style.input_group_text}>
                              Producto id : {input.id}
                           </span>
                           <br />
                        </div>
                     ) : // <div className={style.input_group}>
                     //    <span class={style.input_group_text} id="basic-addon1">
                     //       ID:
                     //    </span>
                     //    <input
                     //       type="text"
                     //       id="id"
                     //       name="id"
                     //       value={input.id}
                     //       onChange={handleChange}
                     //       className={style.input_field}
                     //    />
                     // </div>
                     null}
                  </div>

                  <div className={style.input_group}>
                     <span className={style.input_group_text}>
                        Descripción:{" "}
                     </span>
                     <input
                        className={style.input_field}
                        type="text"
                        placeholder="Descripcion Producto"
                        name="descripcion"
                        value={input.descripcion}
                        onChange={handleChange}
                        required
                     />
                  </div>
                  <div className={style.input_group}>
                     <span className={style.input_group_text}>
                        Cod.Interno Proveedor:{" "}
                     </span>
                     <input
                        className={style.input_field}
                        type="text"
                        placeholder="Codigo Interno del Proveedor"
                        name="cod_proveedor"
                        value={input.cod_proveedor}
                        onChange={handleChange}
                        required
                     />
                  </div>

                  <div className="d-flex p-1">
                     <div className={style.input_group}>
                        <span className={style.input_group_text}>Precio:</span>
                        <label htmlFor="dolar"></label>
                        <input
                           type="number"
                           id="dolar"
                           name="dolar"
                           value={input.dolar}
                           onChange={handleChange}
                           className={style.input_field_number}
                        />{" "}
                        <span className={style.input_group_text}>U$S</span>
                     </div>
                     <div className={style.ciaContainer}>
                        <div className={style.input_group}>
                           <span className={style.input_group_text}>
                              Tamaño ^ :
                           </span>
                           <input
                              type="number"
                              id="size"
                              name="size"
                              value={input.size}
                              onChange={handleChange}
                              className={style.input_field_number}
                           />
                        </div>
                        <div className={style.input_group}>
                           <span className={style.input_group_text}>
                              Diametro Ø :
                           </span>
                           <input
                              type="number"
                              id="gauge"
                              name="gauge"
                              value={input.gauge}
                              onChange={handleChange}
                              className={style.input_field_number}
                           />
                        </div>
                     </div>
                     <div className={style.ciaContainer}>
                        <div className={style.input_group}>
                           <span className={style.input_group_text}>
                              Stock:
                           </span>
                           <input
                              type="number"
                              id="stock"
                              name="stock"
                              value={input.stock}
                              onChange={handleChange}
                              className={style.input_field_number}
                           />
                        </div>

                        <div className={style.input_group}>
                           <span className={style.input_group_text}>
                              Esteril:
                           </span>
                           <input
                              type="number"
                              id="esteril"
                              name="esteril"
                              value={input.esteril}
                              onChange={handleChange}
                              className={style.input_field_number}
                           />
                        </div>
                     </div>
                     {/* <div className={style.input_group}>
                           <span className={style.input_group_text}>
                              Total Stock:  {input.esteril + input.stock }
                           </span>
                        </div> */}
                  </div>
                  {/* <div className={style.input_group}>
                     <span className={style.input_group_text}>Tipo de Insumo:</span>&nbsp;
                     <select
                        name="tipo"
                        id="tipo"
                        onChange={(e) => handleChange(e)}
                        value={input.tipo}
                        className={style.input_field}
                     >
                        <option value="0">Seleccionar</option>
                        {tipoinsu &&
                           tipoinsu.map((ins) => {
                              return (
                                 <option
                                    selected
                                    value={ins.id}
                                    key={ins.id}
                                 >{`${ins.nombre}`}</option>
                              );
                           })}{" "}
                     </select>
                  </div> */}

                  <div className={style.input_group}>
                     <span className={style.input_group_text}>Status:</span>
                     <select
                        name="cod_status"
                        id="cod_status"
                        onChange={(e) => handleChange(e)}
                        value={input.cod_status}
                        className={style.input_field}
                     >
                        <option value="0">Seleccionar</option>
                        {estados &&
                           estados.map((dat) => {
                              return (
                                 <option
                                    selected
                                    value={dat.id}
                                    key={dat.id}
                                 >{`${dat.nombre}`}</option>
                              );
                           })}{" "}
                     </select>
                  </div>
                  <div>
                     {btnGrabar ? (
                        <button className={style.inputBtnNew} type="submit">
                           {state ? "GRABAR" : "AGREGAR"}
                        </button>
                     ) : null}
                     &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                     <button
                        className={style.inputBtnNew}
                        onClick={() => {
                           navigate("/Producto");
                        }}
                     >
                        VOLVER
                     </button>
                  </div>
               </form>
            </div>
         </div>
      </>
   );
}

export default ABMProductos;
